/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Licentietype_Proefperiode3Inputs */

const nl_enums_licentietype_proefperiode3 = /** @type {(inputs: Enums_Licentietype_Proefperiode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proefperiode`)
};

/**

* @param {Enums_Licentietype_Proefperiode3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_licentietype_proefperiode3 = /** @type {((inputs?: Enums_Licentietype_Proefperiode3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Licentietype_Proefperiode3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_licentietype_proefperiode3(inputs)
});
export { enums_licentietype_proefperiode3 as "enums.LicentieType.Proefperiode" }